import { useAuth } from '../contexts/AuthContext';
export default function DrawingPackageGate({ children }) {
    const { drawingPackage } = useAuth();
    if (drawingPackage === null) return <p role="status">Loading…</p>;
    if (!drawingPackage) return <main style={{ padding: 32 }}><h1>3D drawings unavailable</h1><p>To enable this feature, contact your system admin.</p><a href="/dashboard">Return to dashboard</a></main>;
    return children;
}
